import { useContext } from 'react';
import { NavigationContext } from '@annunciate/ui';
export const useOnNavigate = () => {
    const { onNavigate } = useContext(NavigationContext);
    return onNavigate;
};
//# sourceMappingURL=useOnNavigate.js.map